import { useState, useRef, useEffect } from 'react';
import SearchIcon from '@common/components/icons/SearchIcon';
import * as styles from './index.module.css';

export default function Search({ onSearchChange, searchTerm = '' }) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setLocalSearchTerm(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSearchOpen(false);
        setLocalSearchTerm(searchTerm);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [searchTerm]);

  const handleSearchApply = () => {
    if (onSearchChange) {
      onSearchChange(localSearchTerm);
    }
    setIsSearchOpen(false);
  };

  const handleSearchDiscard = () => {
    if (onSearchChange) {
      onSearchChange('');
    }
    setLocalSearchTerm('');
    setIsSearchOpen(false);
  };

  const toggleSearchDropdown = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchApply();
    } else if (e.key === 'Escape') {
      handleSearchDiscard();
    }
  };

  return (
    <div className={`${styles['icon-container']} ${styles['search-wrapper']}`}>
      <button
        onClick={toggleSearchDropdown}
        className={styles['search-button']}
        type="button"
      >
        <SearchIcon />
      </button>

      {isSearchOpen && (
        <div
          className={styles['search-dropdown']}
          ref={dropdownRef}
        >
          <input
            type="text"
            name="agent-search"
            value={localSearchTerm}
            onChange={(e) => setLocalSearchTerm(e.target.value)}
            onKeyDown={handleSearchKeyPress}
            placeholder="Search"
            className={styles['search-input']}
          />

          <div className={styles.divider} />

          <button className={styles['clear-input-btn']} onClick={() => setLocalSearchTerm('')} type="button">🞩</button>

          <button
            onClick={handleSearchApply}
            className={styles['search-submit-btn']}
            type="button"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
}

